<template class="h-100">
         <div v-if="namespace === 'conversations' && !conversation_id" class="text-center pt-5 chat-header">
            <div class="chat-header-wrap">
               <h1 class="text-secondary">
                  <i class="el-icon-chat-line-round"></i>
               </h1>
               <h4 class="text-secondary">Selecione uma conversa</h4>
            </div>

         </div>

         <div v-else>
            <header v-if="showHeader" class="el-drawer__header chat-custom-header" :class="[{'isDrawer': isDrawer}]">
               <span
                  v-if="conversation.ref._id"
                  role="heading"
                  :title="`Chat ${conversation.ref.name}`">
                  {{handleHeaderTitle()}} - <router-link :to="`/bicicleta/${conversation.ref.slug}`">{{conversation.ref.name}}</router-link></span>
               <span
                  v-if="newConversation && namespace === 'bike'"
                  role="heading"
                  title="Conversar com o Anfitrião">
                  {{refData.user.firstName}} {{refData.user.lastName}} - {{refData.bike.info.name}}</span>
            </header>

            <div
               id="chatWrap" class="pl-3 pr-3 chat-wrap h-100"
               :class="{'chat-loaded': !loading.chat}"
            >
               <!-- Loop do objeto chatObj-->
               <div class="h-100 chat-inner">

                  <div v-show="loading.chat"  class="text-center text-secondary loading-chat">
                     <i class="spinner-grow text-secondary"></i>
                  </div>

                  <div id="target" class="inner-card-chat">
                     <div v-for="(item, index) in chat.posts" :key="index">

                        <el-card  class="box-card" :class="{client : handleSenderInteraction(item)}">
                           <div>
                              <div v-if="item.sender">
                                 <div slot="header" class="clearfix header" v-if="item.createdAt">
                                    <div class="text-muted float-left small">{{item.sender.firstName}} {{item.sender.lastName}}</div>
                                    <div :title='item.createdAt | moment("DD/MM/YYYY [às] H:mm:ss")' class="sent-on text-primary small ml-2 float-right"> {{ formatDateChat(item.createdAt) }}</div>
                                 </div>
                              </div>

                              <div v-if="isValidHttpUrl(renderMessage(item.message))">
                                 <el-image
                                    class="w-100"
                                    @click="e => addClassIntoDiv(e)"
                                    :src="renderMessage(item.message)"
                                    :preview-src-list="srcPreviewImageList"
                                    :z-index="10000"
                                    :title="item.message.filename"
                                 >
                                    <div slot="placeholder" class="image-slot w-100">
                                       <b-skeleton-img
                                          card-img="left"
                                          height="100%"
                                          width="100%"
                                       ></b-skeleton-img>
                                    </div>
                                 </el-image>
                              </div>

                              <p class="text item" v-else>
                                 {{ renderMessage(item.message) }}
                              </p>
                           </div>
                        </el-card>
                        <div class="clearfix"></div>
                     </div>
                  </div>

                  <div class="end-chat"></div>
               </div>

               <div>
                  <!-- Formulário para enviar novo texto -->
                  <el-form :model="formChat" :rules="chatRules" ref="formChat" class="form-chat">
                     <el-row :gutter="20">

                        <el-col :span="18">
                           <el-form-item prop="text">
                              <el-input
                                 placeholder="Digite uma mensagem..."
                                 :rows="2"
                                 maxlength="1024"
                                 show-word-limit
                                 type="textarea"
                                 v-model.trim="formChat.text"
                                 v-model="formChat.text"
                                 class="input-text-chat"
                                 @keyup.enter.native="handleEnterInput('formChat')"
                              ></el-input>
                           </el-form-item>
                        </el-col>

                        <el-col :span="6">
                           <el-form-item>
                              <!-- Usado para iniciar novo chat -->
                              <el-button
                                 v-if="namespace === 'bike' && newConversation"
                                 class="btn-chat"
                                 icon="el-icon-position"
                                 :loading="btnChat"
                                 @click="submitNewConversations('formChat')"
                                 type="default"
                              >
                              </el-button>
                              <!-- Usado para enviar nova interação em chat já existente -->
                              <el-button
                                 v-if="namespace && !newConversation"
                                 class="btn-chat"
                                 icon="el-icon-position"
                                 :loading="btnChat"
                                 @click="submitInteraction('formChat')"
                                 type="default"
                              >
                              </el-button>
                              <!-- Usado no pedido -->
                              <el-button
                                 v-if="!namespace"
                                 class="btn-chat"
                                 icon="el-icon-position"
                                 :loading="btnChat"
                                 @click="submitTextChat('formChat', bookObj._id)"
                                 type="default"
                              >
                              </el-button>
                           </el-form-item>
                        </el-col>
                     </el-row>
                  </el-form>

                  <!-- Anexo -->
                  <el-form
                     :model="file"
                     class="upload-file-chat"
                     size="small"
                     enctype="multipart/form-data"
                     method="post"
                     @submit.stop.prevent
                     :disabled="loading.saveFile || loading.file"
                  >
                     <el-upload
                        action=""
                        ref="file"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="setFileUpload"
                        title="Enviar foto"
                     >
                        <el-button
                           icon="el-icon-paperclip"
                           circle type="warning"
                           :loading="loading.saveFile || loading.file"
                        >
                        </el-button>
                     </el-upload>
                  </el-form>
               </div>
            </div>
         </div>
</template>

<script>
import OrderService from "@/services/order.service";
import imageCompression from "browser-image-compression";
import header from "@/services/header";
import BikeImg from "@/helpers/GetBikeCover";
import ConversationsService from "../services/conversations";

export default {
   name: 'Chat',
   components: {

   },
   props: {
      userId: {
         type: String,
      },
      open: {
         type: Boolean,
         default: false
      },
      bookObj: {
         type: Object
      },
      isDrawer: {
         type: Boolean,
         default: false
      },
      namespace: {
         type: String,
         default: ''
      },
      conversationID: {
         type: String,
         default: ''
      },
      refID: {
         type: String,
         default: ''
      },
      refData: {
         type: Object,
      },
      showHeader: {
         type: Boolean,
         default: false
      }
   },

   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         file: null,
         chat: {
            btnStatus: false,
            order: {
               customer: {},
               owner: {},
               orderN: null
            },
            orderId: '',
            posts: []
         },
         conversation: {
            createdAt: null,
            updatedAt: null,
            recipient: {
               firstName: '',
               lastName: ''
            },
            sender: {
               firstName: '',
               lastName: ''
            },
            ref: {
               name: '',
               bikeValue: 0,
               dailyValue: 0,
               slug: '',
               _id: '',
            }
         },
         formChat: {
            text: ''
         },
         chatRules: {
            text: [
               {required: true, message: 'Por favor, digite sua mensagem', trigger: 'blur'},
               {
                  min: 2,
                  max: 1024,
                  message: 'Você precisa digitar ao menos 2 caracteres.',
                  trigger: 'blur'
               }
            ],
         },
         btnChat: false,
         loading: {
            chat: false,
            file: false,
            saveFile: false
         },
         fileList: [],
         fileUri: '',
         srcPreviewImageList: [],
         sender: null,
         polling: null,
         newConversation: false,
         conversation_ID: '',
         interactionsCount: 0
      }
   },
   async mounted() {
      switch(this.namespace) {
         case 'conversations':
            this.conversationID ? await this.getInteractions(this.conversationID || this.conversation_id, this.refID) : null
            break
         case 'bike':
            this.refID ? await this.getInteractions(this.conversationID, this.refID) : null
            if (this.newConversation) {
               this.formChat.text = 'Olá, gostaria de uma informação.'
               await this.submitNewConversations('formChat')
            }
            break
         default:
            this.bookObj._id ? await this.getChat(this.bookObj._id, this.bookObj) : null
      }
   },
   methods: {

      async getChat(orderId, order) {
         try {
            this.loading.chat = true

            const viewedBy = this.userId ? 'owner' : 'customer'

            const chat = await OrderService.getChat(orderId, viewedBy)

            if (chat) {

               setTimeout(() => {
                  this.loading.chat = false
                  setTimeout(() => {
                     this.chat.posts = chat.data.posts
                     this.chat.order.owner = order.owner
                     this.chat.order.customer = order.customer
                     this.chat.order.orderN = order.orderN
                     this.chat.orderId = chat.data.orderId
                     let arrFilesList = []

                     chat.data.posts.map(v => {
                        let b = this.renderMessage(v.message)

                        if ( this.isValidHttpUrl(b) ) {
                           arrFilesList.push(b)
                        }
                     })

                     this.srcPreviewImageList = arrFilesList
                     this.scrollLastItem('#target', 'instant')


                     //this.scrollLastItem('end-chat', 'instant')
                  }, 200)


               }, 400)

            }


         } catch (e) {
            this.$message.error(e);
         }

      },

      async getInteractions(conversationID, ref, isPolling = false, scrollEnd = true) {
         try {

            if (!isPolling)  this.loading.chat = true

            const count = this.interactionsCount

            const conversation = await ConversationsService.getInteractions(conversationID, ref)

            // Quando for uma nova conversa na página da bike
            if (!conversation) {
               this.newConversation = true
               this.loading.chat = false
            }

            if (conversation) {
               this.interactionsCount = conversation.interactions.length
               this.conversationID = conversation._id
               this.conversation.recipient = conversation.recipient
               this.conversation.sender = conversation.sender
               this.conversation.ref = conversation.ref
               this.conversation.createdAt = conversation.createdAt
               this.conversation.updatedAt = conversation.updatedAt
               this.sender = conversation.sender._id === this.currentUser.user._id || false

               setTimeout(() => {
                  this.loading.chat = false

                  setTimeout(() => {
                     this.chat.posts = conversation.interactions
                     let arrFilesList = []

                     conversation.interactions.map(v => {
                        let b = this.renderMessage(v.message)

                        if ( this.isValidHttpUrl(b) ) {
                           arrFilesList.push(b)
                        }
                     })
                     this.srcPreviewImageList = arrFilesList

                     if (scrollEnd || count !== conversation.interactions.length) {
                        this.scrollLastItem('#target', 'instant')
                        this.scrollLastItem('end-chat', 'instant')
                     }

                  }, isPolling ? 50 : 200)

               }, isPolling ? 100 : 400)

            }

         } catch (e) {
            this.$message.error(e);
         }

      },

      // Inicia um novo chat. Usado por hora na página da bike.
      async submitNewConversations(formName) {
         this.$refs[formName].validate(async (valid) => {
            if (valid) {

               try {
                  this.btnChat = true;

                  const payloadChat = {
                     ref: this.refID,
                     namespace: 'bike',
                     message: this.formChat.text
                  }

                  const sendChat = await ConversationsService.postConversation(payloadChat)

                  if (sendChat) {
                     this.conversation.recipient = sendChat.conversation.recipient
                     this.conversation.sender = sendChat.conversation.sender
                     this.conversation.ref = sendChat.conversation.ref
                     this.conversation.createdAt = sendChat.conversation.createdAt
                     this.conversation.updatedAt = sendChat.conversation.updatedAt
                     this.sender = sendChat.conversation.sender._id === this.currentUser.user._id || false

                     this.conversation_ID = sendChat.conversation._id
                     this.resetForm(formName)
                     this.chat.posts = sendChat.conversation.interactions
                     this.newConversation = false
                     this.scrollLastItem('#target', 'smooth')
                     this.btnChat = false
                  }

               } catch (e) {
                  this.btnChat = false
               }

            } else {
               this.btnChat = false;
               return false;
            }
         });
      },

      async submitInteraction(formName) {
         this.$refs[formName].validate(async (valid) => {
            if (valid) {

               try {
                  this.btnChat = true;

                  const payloadChat = {
                     conversationID: this.conversationID || this.conversation_id,
                     message: this.formChat.text,
                  }

                  const sendChat = await ConversationsService.updateInteraction(payloadChat)

                  if (sendChat) {
                     this.resetForm(formName)
                     payloadChat.sender = this.currentUser.user._id
                     this.chat.posts = sendChat.conversation.interactions
                     this.scrollLastItem('#target', 'smooth')
                     this.btnChat = false
                     this.$emit('onMessageSent')
                  }

               } catch (e) {
                  this.btnChat = false
               }

            } else {
               this.btnChat = false;
               return false;
            }
         });
      },

      async submitTextChat(formName, orderId) {
         this.$refs[formName].validate(async (valid) => {
            if (valid) {
               try {
                  this.btnChat = true;

                  const payloadChat = {
                     orderId,
                     message: this.formChat.text,
                     sentBy: this.userId ? 'customer' : 'owner'
                  }

                  const sendChat = await OrderService.postChat(payloadChat)

                  if (sendChat) {
                     this.resetForm(formName)
                     this.chat.posts.push(payloadChat)
                     this.scrollLastItem('#target', 'smooth')
                     this.btnChat = false
                  }

               } catch (e) {
                  this.btnChat = false
               }

            } else {
               this.btnChat = false;
               return false;
            }
         });
      },

      formatDateChat(date) {
         return this.$moment(date).utc().fromNow()
      },

      checkUserChat(by) {

         if (this.userId && by === 'owner') {
            return true
         } else if (!this.userId && by === 'customer') {
            return true
         } else {
            return false
         }

      },

      resetForm(formName) {
         this.$refs[formName].resetFields();
      },

      scrollLastItem(divID, effect) {

         setTimeout(() => {
            const el = document.querySelector(divID);
            if (el) {
               // Use el.scrollIntoView() to instantly scroll to the element
               el.scrollIntoView({block: "end", behavior: effect});
            }
         }, 500)

      },

      close() {
         this.open = false
      },

      renderMessage(m) {

         let message;

         switch (typeof m) {
            case "object":
               message = this.getCover(m)
               break;
            default:
               message = m
         }
         return message
      },

      getCover(uri) {
         return BikeImg.getCover(uri);
      },

      isValidHttpUrl(string) {
         let url
         try {
            url = new URL(string);
         } catch (_) {
            return false;
         }
         return url.protocol === "http:" || url.protocol === "https:";
      },

      setFileUpload(file) {

         this.loading.file = true
         this.fileUri = ''

         setTimeout(() => {
            if (this.photoIsOK(file)) {

               let imageFile = file.raw;

               let options = {
                  maxSizeMB: 0.4,
                  maxWidthOrHeight: 1200,
                  useWebWorker: true,
                  maxIteration: 20,
                  onProgress: () => false
               };

               imageCompression(imageFile, options)
                  .then((compressedFile) => {
                     this.fileUri = URL.createObjectURL(compressedFile);

                     var file = new File([compressedFile], compressedFile.name, {
                        type: compressedFile.type
                     });

                     this.file = file;
                     this.postImage()
                     this.loading.file = false
                     this.imageSaveBtn = true
                  })
                  .catch(function (error) {
                     this.loading.file = false
                     this.$message.error(`Ops, algo deu errado. Erro: ${error}`);
                  });
            }

         }, 100)

      },

      photoIsOK(file) {

         const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

         if (!allowedTypes.includes(file.raw.type)) {
            this.$message.error('ATENÇÃO: Somente imagens no formato JPEG, JPG e PNG.');
            this.loading.file = false;
            return false;
         }

         const maxSize = file.raw.size > 10000000;

         if (maxSize) {
            this.$message.error('A foto não deve ser maior que 10mb.');
            this.loading.file = false;
            return false
         }

         return true;
      },

      postImage() {
         this.loading.saveFile = true;

         let formData = new FormData();
         formData.append('file', this.file);
         formData.append('nameSpace', 'chat');

         const fileUri = `${this.baseUrl + this.apiV1}/site/upload`;

         this.axios.post(fileUri, formData, header)
            .then(async (response) => {

               // Usado nos pedidos
               if (!this.namespace) {
                  const sendChat = await OrderService.postChat({
                        orderId: this.chat.orderId,
                        message: response.data.doc,
                        sentBy: this.userId ? 'customer' : 'owner'
                  })
                  let post = sendChat.data.data.slice(-1).pop()

                  this.chat.posts.push(post)

                  let b = this.renderMessage(post.message)

                  if ( this.isValidHttpUrl(b) ) {
                     this.srcPreviewImageList.push(b)
                  }

                  this.scrollLastItem('#target', 'smooth')

                  this.btnChat = false
               }

               // Usado para o chat com base no namespace
               if (this.namespace === 'conversations' || this.namespace === 'bike') {

                  let payloadChat, sendChat

                  if (!this.newConversation) {
                     payloadChat = {
                        conversationID: this.conversationID || this.conversation_id,
                        message: response.data.doc,
                     }
                     sendChat = await ConversationsService.updateInteraction(payloadChat)
                  }

                  if (this.newConversation) {
                     payloadChat = {
                        ref: this.refID,
                        namespace: 'bike',
                        message: response.data.doc
                     }

                     sendChat = await ConversationsService.postConversation(payloadChat)
                  }

                  if (sendChat) {
                     this.conversation_ID = sendChat.conversation._id
                     this.conversation.recipient = sendChat.conversation.recipient
                     this.conversation.sender = sendChat.conversation.sender
                     this.conversation.ref = sendChat.conversation.ref
                     this.conversation.createdAt = sendChat.conversation.createdAt
                     this.conversation.updatedAt = sendChat.conversation.updatedAt
                     this.sender = sendChat.conversation.sender._id === this.currentUser.user._id || false
                     payloadChat.sender = this.currentUser.user._id
                     this.chat.posts = sendChat.conversation.interactions
                     this.newConversation = false

                     let arrFilesList = sendChat.conversation.interactions.map(v => {
                        let message = this.renderMessage(v.message)
                        if ( this.isValidHttpUrl(message) ) {
                           return message
                        }
                     }).filter(f => f !== undefined)

                     this.srcPreviewImageList = arrFilesList
                     this.scrollLastItem('#target', 'smooth')
                     this.btnChat = false
                     this.$emit('onMessageSent')
                  }
               }


               this.loading.saveFile = false;
               this.loading.file = false;
            })
            .catch((e => {
               this.$message.error(e.response.data.message || e);
               this.loading.saveFile = false;
               this.loading.file = false;
            }));
      },

      blobToFile(theBlob, fileName) {
         //A Blob() is almost a File() - it's just missing the two properties below which we will add
         theBlob.lastModifiedDate = new Date();
         theBlob.name = fileName;
         return theBlob;
      },

      //Usado para resolver problema de z-index do modal de visualização da imagem
      addClassIntoDiv(div) {

         let x = document.getElementsByClassName("fixTheIndex");
         if(x.length > 0) { x[0].classList.remove("fixTheIndex"); }

         //obter o pai, a 4 níveis acima
         div.path[5].classList.add('fixTheIndex')

        setTimeout(() => {

           var closeModal = document.querySelector('.el-image-viewer__close')

           closeModal.addEventListener("click", () => {

              let x = document.getElementsByClassName("fixTheIndex");
              if(x.length > 0) { x[0].classList.remove("fixTheIndex"); }
           })
        }, 500)

      },

      handleSenderInteraction(item) {
         if (!this.namespace) {
            return this.checkUserChat(item.sentBy)
         }

         if (item.sender === null)
            return true

         if (item.sender) {
            return this.currentUser.user._id !== item.sender._id
         }
      },

      // Verifica a cada 1min se tem nova mensagem.
      checkNewInteraction() {
         if(this.conversationID || this.conversation_id || this.refID) {
            this.polling = setInterval(async() => {
               await this.getInteractions(this.conversationID || this.conversation_id, this.refID, true, false)
            }, 10000) // 30 segundos
         }
      },

      handleHeaderTitle() {
         let title
         if (this.sender) {
            title = `${this.conversation.recipient.firstName} ${this.conversation.recipient.lastName}`
         } else {
            title =`${this.conversation.sender.firstName} ${this.conversation.sender.lastName}`
         }
         return title
      },

      handleEnterInput(formName) {
         if (this.newConversation) this.submitNewConversations(formName)
         if (this.namespace && !this.newConversation) this.submitInteraction(formName)
         if (!this.namespace) this.submitTextChat(formName, this.bookObj._id)
      }
   },
   beforeDestroy () {
      this.newConversation = false
      clearInterval(this.polling)
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      conversation_id() {
         return this.conversationID || this.conversation_ID
      }
   },
   watch: {
      'formChat.text' : function (n) {
         this.formChat.text =  n.replace(/(\r\n|\n|\r)/gm, "");
      },
      'conversationID': function (id) {
         if (id) {
            if (!this.newConversation) {
               this.getInteractions(id)
               this.checkNewInteraction()
            }
         }
      }

   }
};
</script>

<style lang="scss">
.upload-file-chat {
   position: absolute;
   bottom: 65px;
   z-index: 10000000;
   right: 33%;
   transform: scale(0.8);
   .el-button {
      line-height: 0;
      font-size: 20px;
      padding: 9px;
   }

   @media screen and (max-width: 992px) {
      right: 33% !important
   }
}

.chat-pedale {

   .el-drawer__body {
      &::-webkit-scrollbar {
         width: 5px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
         background: #64985e;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
         background: #abd2a3;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
         background: #528d4c;
      }
   }

   .el-drawer__close-btn {
      z-index: 10;
   }
   .chat-custom-header {
      &.isDrawer {
         position: absolute;
         top: 5px;
         width: 90%;
         background: transparent;
      }

      span {
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }
   }
   .el-loading-mask {
      top: 60px;
      bottom: auto;
      .el-icon-loading, .el-loading-text {
         color: #fAfd63;
      }
      .el-loading-spinner i {
         color: #fAfd63;
         font-size: 25px;
      }
   }
   .el-image-viewer__mask {
      opacity: 0.9;
   }

   .btn-chat {
      width: 100%;
      font-size: 20px !important;
      color: #53a24a;
   }
}

.el-image-viewer__wrapper {
   .el-icon-circle-close {
      color: #fff;
   }
}

.image-slot {
   .spinner-grow {
      color: #56b54c;
      opacity: 0.5;
   }
}

.dashboard.my-bikes, .dashboard.my-reservations {
   .upload-file-chat {
      bottom: 55px;
   }
}


</style>
